<template>
  <div>
    <!-- Home Page -->
    <b-row v-if="this.$route.name === 'home'" :class="postsRow" class="homePageNews">
      <b-col
        v-for="(proNews, index) in allposts.slice(0, 4)"
        :config="config"
        :key="index"
        lg="3" 
        md="6"
        sm="12"
        cols="12"
        class="bottomPad"
      >
        <b-card
          title="News"
          :config="config"
          :sub-title="proNews.title.rendered"
          :img-src="proNews.better_featured_image.source_url.replace('https://bigeasytour.co.za/', 'https://live-smt.ocs-software.com/')"
          img-alt="Image"
          img-top
          tag="article"
        >
          <b-card-text>
            <b-button :to="'/' + proNews.slug" class="postBtn HomeBTN">View Article</b-button>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>


    <!-- News Page -->

    <b-row v-if="feat === 'true' && this.$route.name === 'News'" :class="postsRow">
      <b-col
        v-for="(proNews, index) in allposts.slice(0, 2)"
        :key="index"
        :config="config"
        lg="6"
        md="6"
        class="bottomPad"
      >
        <b-nav-item :to="'/' + proNews.slug">
          <b-card
            title="News"
            :sub-title="proNews.title.rendered"
            :img-src="proNews.better_featured_image.source_url.replace('https://bigeasytour.co.za/', 'https://live-smt.ocs-software.com/')"
            img-alt="Image"
            img-top
            tag="article"
            class="NewsPageImage"
            :config="config"
          >
            <b-card-text>
              <span class='hozText' v-html="proNews.excerpt.rendered"></span>
              <b-button :to="'/' + proNews.slug" class="postBtn">View Article</b-button>
            </b-card-text>
          </b-card>
        </b-nav-item>
      </b-col>
    </b-row>

    <b-row v-if="feat === 'false' && this.$route.name === 'News'" :class="postsRow" class="overflowRight">
      <b-col
        v-for="(proNews, index) in allposts.slice(3, 6)"
        :key="index"
        lg="4"
        md="6"
        class="bottomPad overflowRightInner"
        :config="config"
      >
        <b-nav-item :to="'/' + proNews.slug">
          <b-card
            title="News"
            :sub-title="proNews.title.rendered"
            :img-src="proNews.better_featured_image.source_url.replace('https://bigeasytour.co.za/', 'https://live-smt.ocs-software.com/')"
            img-alt="Image"
            img-top
            tag="article"
            :config="config"
            class="cardBody"
          >
            <b-card-text>
              <b-button :to="'/' + proNews.slug" class="postBtn HomeViewArticle">View Article</b-button>
            </b-card-text>
          </b-card>
        </b-nav-item>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import apiCall from "@/services/api.js";
export default {
  name: "interNews",
  props: ["cat", 'feat', 'config'],
  data() {
    return {
      allposts: [],
      postsRow: "posts",
      postImg: "postImg",
    };
  },
  methods: {
    // newLabel: function(label) {
    //   if (this.cat === "8") label = "News";
    //   return label;
    // },
  },
  created() {
    const json = "wp/v2/posts";
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.allposts = data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
a.btn.postBtn.q-schoolart.btn-secondary {
  line-height: 23px;
}
/* .q-schoolart {
  line-height: 23px;
} */
a.btn.postBtn.HomeBTN.btn-secondary {
  border: 0px solid transparent;
  background: #000;
  color: #fff!important;
  font-size: 11px;
}
a.btn.postBtn.btn-secondary {
  border: 1px solid #000;
  background: #000;
  color: #fff!important;
  font-size: 11px;
}
a.btn.postBtn.btn-secondary:hover {
  border: 1px solid #E0E0E0;
  background: #2c2c2c!important;
  color: #fff!important;
  font-size: 11px;
}
article.card.scoreCard > .card-img-top {
  max-height: initial;
}
.blogButton {
  margin: auto;
  background: #000;
  border: none;
  color: #fff!important;
  border-radius: 0;
  padding: 5px 20px;
  width: 200px;
  font-size: 11px;
  text-transform: capitalize;
  border: 1px solid #E0E0E0;
  font-weight: bold;
}
.blogButton:hover {
  margin: auto;
  background: #2c2c2c;
  border: none;
  color: #fff!important;
  border-radius: 0;
  padding: 5px 20px;
  width: 200px;
  font-size: 11px;
  text-transform: capitalize;
  border: 1px solid #E0E0E0;
  font-weight: bold;
}
.overflowRightInner{
  display: inline-block;
  float: none;
}
.overflowRight{
  overflow-x: auto;
  white-space: nowrap;
  display: block;
}
article.card.cardBody > .card-body > .card-subtitle {
  margin-bottom: 20px !important;
}
::v-deep article.card.cardBody > .card-body {
  box-shadow: 0px 0px 0px #00000029;
  padding-left: 0;
  padding-right: 0;
}
::v-deep .card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
  box-shadow: 0px 3px 6px #00000029;
}
::v-deep article.card.NewsPageImage > img {
  max-height: 400px;
  min-height: 400px;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0px solid rgba(0, 0, 0, 0.125);
  /* border-radius: 10px; */
  border-radius: 10px 10px 0px 0px;
}
.hozCol.scorePage.col-md-7 {
  padding-right: 50px;
}
.thescoreTop {
  border-radius: 20px!important;
}
.scorePage > div {
  padding: 0rem;
}
img.card-img-top {
  max-height: 180px;
  min-height: 180px;
  border-radius: 0px;
  object-fit: cover;
  object-position: top;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.theScoreCard {
  border-radius: 20px!important;
}
.card-text:last-child {
  margin-bottom: 0;
  color: #000;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  width: 100%;
}
span.postText {
  font-size: 12pt;
}
h1.postsTitle {
  font-size: 20pt;
  padding-top: 15px;
  padding-bottom: 15px;
  white-space: nowrap;
  width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
 
}
.overflowImage {
  overflow: hidden;
  height: 278px;
}

.card-title {
  font-weight: 100;
  letter-spacing: -0.5px;
  color: #9aa5ac;
  margin-top: -2px;
  margin-bottom: -5px;
  font-size: 11px;
  color: #000;
  text-transform: capitalize;
}
.feat > .card-body > .card-subtitle {
  font-size: 23pt !important;
}
.card-subtitle {
  color: #6C6C6C !important;
  /* font-weight: 300; */
  font-weight: 700;
  font-size: 13px;
  background-color: #fff;
  margin-top: 13px;
  margin-bottom: 5px !important;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.viewAll {
  position: relative;
  top: 1em;
  color: #000;
  font-weight: 600 !important;
  font-size: 14px;
  padding-left: 15px;
}
.noRightPad {
  padding-right: 0;
  padding-left: 5px;
}
.bottomPad {
  padding-bottom: 20px;
}
.nav-link {
  padding: 0;
}

.mobShow {
  display: none;
}

.card-text {
  padding-top: 7px;
}
.postBtn {
  text-align: center;
  display: block;
  margin: auto;
  background: #000;
  border: none;
  color: #fff!important;
  border-radius: 0;
  padding: 5px 20px;
  width: 100%;
  font-size: 11px;
  text-transform: capitalize;
  border: 1px solid #E0E0E0;
  font-weight: bold;
  line-height: 22px;
  /* height: 35px; */
}
.postBtn:hover{
  background-color: #2c2c2c;
  color: #fff!important;
}
.hoz > h4 {
  color: #046532;
  font-size: 18px;
  line-height: 25px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 15px;
}
.hozCol {
  padding: 1.25rem;
}
.hozImg {
  border-radius: 10px 0 0 10px;
}
.hozTop {
  border-radius: 10px 0 0 10px;
}
::v-deep .hozText>p{
  margin-bottom: 25px;
  color: #6C6C6C;
  font-size: 13px;
}
@media only screen and (max-width: 480px) {
  #mobilePost {
    padding-top: 2%;
    padding-bottom: 2%;
  }
  .feat {
    height: 485px !important;
  }
  .featMob {
    height: 350px !important;
  }
  img.card-img-top {
    max-height: inherit;
    min-height: 263px!important;
    border-radius: 0px;
  }
  .overflowRight {
    overflow-x: auto;
    white-space: nowrap;
    display: inline-flex;
    width: 108%;
  }
}
@media only screen and (max-width: 1165px) {
  #mobilePost:last-child {
    padding-right: 15px;
    margin-top: 2em;
  }
  div#mobilePost {
    margin-top: 1em;
  }
}

@media only screen and (max-width: 990px) {
  .homePageNews {
    flex-wrap: nowrap;
    overflow: scroll;
  }
  img.card-img-top {
    min-height: 219px;
    border-radius: 0px;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: top;
    object-position: top;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0px solid rgba(0, 0, 0, 0.125);
    border-radius: 0px;
  }
  .hozImg {
    border-radius: 10px 0 0 0px;
  }
  .hozCol.scorePage.col-md-7 {
    padding-right: 30px;
    padding-left: 30px;
  }
  img.card-img-top {
    max-height: initial;
    /* min-height: auto; */
    border-radius: 0px;
  }
  .featMob {
    height: 621px;
  }
  .noRightPad {
    padding: 15px;
  }
  .mobShow {
    display: block;
  }
.blogButton {
  margin: auto;
  background: #000;
  border: none;
  color: #fff!important;
  border-radius: 0;
  padding: 5px 20px;
  width: 100%;
  font-size: 11px;
  text-transform: capitalize;
  border: 1px solid #E0E0E0;
  font-weight: bold;
}
.blogButton:hover {
  margin: auto;
  background: #000;
  border: none;
  color: #fff!important;
  border-radius: 0;
  padding: 5px 20px;
  width: 100%;
  font-size: 11px;
  text-transform: capitalize;
  border: 1px solid #E0E0E0;
  font-weight: bold;
}
}

</style>
